import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_CIMITERI } from '../queries/cimiteri';

export const fetchCimiteri = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: { where },
      query: FETCH_CIMITERI,
    });

    return result.data.cimiteris.edges.map((edge) => edge.node);
  } catch (error) {
    console.error('[fetchCimiteri] Error:', error);
    return [];
  }
};
